import React, { useState, useEffect } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import Style from "../../assets/jsStyles";
import swal from "sweetalert";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";

const cardStyle = {
  style: {
    base: {
      iconColor: "#000",
      color: "#000",
      paddingLeft: "10px",
      fontFamily: "Roboto, sans-serif",
      fontSize: "16px",
      "::placeholder": {
        color: "#aaa",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
};

function Product({ product, verifyAndDownload, setLoader, downloadLink }) {
  var dWidth = "90%";
  const stripe = useStripe();
  const elements = useElements();
  const [paidFor, setPaidFor] = useState(false);
  const [country, selectCountry] = useState();
  const [region, selectRegion] = useState();
  const [error, setError] = useState(null);
  const [name, setName] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [lineOne, setLineOne] = useState("");

  useEffect(() => {
    if (downloadLink) {
      setPaidFor(true);
      setLoader(false);
    }
  }, [
    downloadLink,
    setLoader,
    verifyAndDownload,
    product.description,
    product.price,
  ]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setLoader(true);
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: elements.getElement(CardElement),
      });

      if (!error) {
        console.log("Stripe 23 | token generated!", paymentMethod);
        console.log("selectRegion ==> ", selectRegion);
        console.log("selectCountry ==> ", selectCountry);
        //send token to backend here
        // const respApi = await apiService.makePayment(user._id, amount, paymentMethod.id);
        const cardElement = elements.getElement(CardElement);
        cardElement.clear();
        const addressNameObj = {
          name,
          address: {
            line1: lineOne,
            postal_code: zipcode,
            city: region,
            state: region,
            country: country,
          },
        };
        setLoader(false);
        const paymentData = await verifyAndDownload(
          product.price,
          paymentMethod.id,
          addressNameObj
        );

        if (paymentData.actionRequired) {
          stripe
            .confirmCardPayment(paymentData.data.payment_intent_client_secret)
            .then(async (result) => {
              if (result.error) {
                console.log(result.error);
                // Show error in payment form
              } else {
                await verifyAndDownload(
                  null,
                  null,
                  null,
                  paymentData.data.paymentId,
                  true
                );
              }
            });
        }
      } else {
        setLoader(false);
        swal({
          title: "Failed!",
          text: "Failed to complete payment! Please try again",
          icon: "failures",
          button: "Ok",
        });
      }
    } catch (e) {
      setLoader(false);
      swal({
        title: "Failed!",
        text: e.message
          ? e.message
          : "Failed to complete payment! Please try again",
        icon: "failures",
        button: "Ok",
      });
    }
  };

  if (paidFor) {
    return (
      <div style={{ justifyContent: "center", textAlign: "center" }}>
        <h1>Congrats, your file is getting downloaded!</h1>
        <h2>
          If Download doesn't start{" "}
          <a href={downloadLink || "https://tangentmotorsport.com"}>
            <b>Click Here</b>
          </a>
        </h2>
      </div>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      style={{ justifyContent: "center", textAlign: "center" }}
    >
      {error && <div>Uh oh, an error occurred! {error.message}</div>}
      <h1>
        {product.description} for &euro;{product.price}
      </h1>
      <div className="payment-card-container">
        <input
          type="text"
          onChange={(e) => {
            setName(e.target.value);
          }}
          placeholder="Your Name"
          style={Style.formInput(dWidth, "black")}
          name="name"
          value={name}
        ></input>
      </div>
      <div className="payment-card-container">
        <input
          type="text"
          onChange={(e) => {
            setLineOne(e.target.value);
          }}
          placeholder="Address Line 1"
          style={Style.formInput(dWidth, "black")}
          name="lineone"
          value={lineOne}
        ></input>
      </div>
      <div className="payment-card-container">
        <CountryDropdown
          value={country}
          style={Style.formInput(dWidth, "black")}
          // labelType="short"
          valueType="short"
          onChange={(val) => selectCountry(val)}
        />
      </div>
      <div className="payment-card-container">
        <RegionDropdown
          country={country}
          style={Style.formInput(dWidth, "black")}
          value={region}
          countryValueType="short"
          // labelType="short"
          valueType="short"
          onChange={(val) => selectRegion(val)}
        />
      </div>
      <div className="payment-card-container">
        <input
          type="text"
          onChange={(e) => {
            setZipcode(e.target.value);
          }}
          placeholder="Zipcode"
          style={Style.formInput(dWidth, "black")}
          name="zipcode"
          value={zipcode}
        ></input>
      </div>
      <div className="payment-card-container">
        <CardElement options={cardStyle} id="card-element" />
      </div>
      <div className="payment-btn-container">
        <input
          type="submit"
          style={Style.formInput(dWidth, "black", "60px", "18px")}
          value="Pay Now"
        ></input>
      </div>
      {/* <div ref={paypalRef} id="paypal-button-container" /> */}
    </form>
  );
}

export default Product;
